import React, { useState, useEffect } from "react";

import { Redirect } from "react-router-dom";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import styles from "./Login.module.scss";
import Headline from "../../Headline/Headline";
import LoginInput from "./LoginInput";

import * as GlobalConstant from "../../Constants/GlobalConstant"
import * as AuthenticationActions from "../../../middleware/Store/Actions/AuthenticationActions";
import * as ErrorUtils from "../../Utils/ErrorUtils";
import * as AuthenticationUtils from "../../Utils/AuthenticationUtils";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "LOGIN"

const Login = (props) => {
    const intl = useIntl();
    const [loginProgress, setLoginProgress] = useState(false);
    const [authenticationRedirect, setAuthenticationRedirect] = useState(null);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        window.scrollTo(0, 0);
        resetEnvironment();
    }, []);

    const resetEnvironment = () => {
        props.clearEnvironment();
        props.clearAuthentication();
    }

    const handleEmailChange = (email) => {
        if (email && email.length > 0) {
            resetEnvironment();
            return props.getUserEnvironment(email)
                .then((data) => {//environment
                    return props.getUserAuthentication(email)
                })
                .then((data) => {
                    return Promise.resolve();
                })
                .catch((errorPayload) => {
                    return Promise.reject(errorPayload);
                });
        } else {
            resetEnvironment();
            return Promise.resolve();
        }
    }

    const handleServerChange = (email, serverIndex) => {
        props.selectUserEnvironment(serverIndex);
        return props.getUserAuthentication(email)
            .then((data) => {
                return Promise.resolve();
            })
            .catch((errorPayload) => {
                return Promise.reject(errorPayload);
            });
    }

    const handleAuthenticationChange = (authenticationIndex) => {
        props.selectUserAuthentication(authenticationIndex);
    }

    const handleLogin = (data) => {
        LogService.trace(LOG_TAG, "handleLogin");
        setLoginProgress(true);
        if (AuthenticationUtils.isRainbowAuthentication(props.account)) {
            return props.login(data)
                .then(() => {
                    setLoginProgress(false);
                    const callback = () => {
                        setAuthenticationRedirect(<Redirect to={GlobalConstant.DASHBOARD_PATH} />);
                    }
                    return Promise.resolve({action: callback});
                })
                .catch((errorPayload) => {
                    setLoginProgress(false);
                    return Promise.reject({ errorPayload: errorPayload });
                });
        } else if (AuthenticationUtils.isSsoAuthentication(props.account)) {
            const ssoUrl = AuthenticationUtils.getSelectedLoginUrl(props.account);
            const challenge = AuthenticationUtils.getQueryParameterInPathString(ssoUrl, "challenge");
            return props.getSsoLoginUrl(ssoUrl, challenge, window.version)
                .then((redirectUrl) => {
                    // setLoginProgress(false);
                    document.location.replace(redirectUrl);
                    return Promise.resolve({ keepSpinner: true });
                });
        };

        LogService.error(LOG_TAG, "handleLogin", "authentication not handled");
        setLoginProgress(false);
        return Promise.reject({ errorPayload: ErrorUtils.parseErrorAndReturnPayload("Authentication not handled") });
    }

    LogService.trace(LOG_TAG, "render");

    const enableLoginButton = !loginProgress && AuthenticationUtils.isEnvironmentAvailable(props.account) && AuthenticationUtils.isAuthenticationAvailable(props.account);

    let createAccountUrl = null;
    let lostPasswordUrl = null;
    let selectedServerUrl = AuthenticationUtils.getSelectedServerUrl(props.account);
    if (!selectedServerUrl) {
        selectedServerUrl = AuthenticationUtils.getBaseServerUrl(props.account);
    }
    if (selectedServerUrl) {
        createAccountUrl = new URL("#/subscribe", selectedServerUrl);
        createAccountUrl.host = AuthenticationUtils.WebClientPrefix + createAccountUrl.host; //web. valid only on .com
        lostPasswordUrl = new URL("login", selectedServerUrl);
        lostPasswordUrl.host = AuthenticationUtils.WebClientPrefix + lostPasswordUrl.host; //web. valid only on .com
    }

    const title = intl.messages.loginTitle;
    const subtitle = "";

    return (
        <div>
            {authenticationRedirect}
            <Headline
                title={title}
                subtitle={subtitle}
                style={{ textAlign: "center" }}
            />


            <div className="row">
                <div className="mx-auto d-table col-sm-10 col-md-8 col-lg-6">
                    <div className="card mb-0" >
                        <div className="text-center mt-1">
                            <img src="./images/signin.svg" alt="Sign-in" className={styles.img} />
                        </div>
                        <div className="card-body mt-2">                       
                            <h5 className="card-title text-center">{intl.messages.loginMessage}</h5>
                        </div>
                        <div className="m-2">    
                            <LoginInput
                                server={props.account.environment}
                                authentication={props.account.authentication}
                                selectedServerIndex={props.account.selectedServerIndex}
                                selectedAuthenticationIndex={props.account.selectedLoginIndex}
                                enableLoginButton={enableLoginButton}
                                onLoginEmailChange={handleEmailChange}
                                onServerChange={handleServerChange}
                                onAuthenticationChange={handleAuthenticationChange}
                                onLogin={handleLogin}
                                forgotPasswordUrl={lostPasswordUrl}
                            />
                        </div>
                    </div>                  

                    <p id="login_footer" className="card-text mt-1 ml-2 mb-5">
                        {intl.messages.loginNoAccount}
                        <a className="btn-link-green ml-1" href={createAccountUrl} >
                            {intl.messages.loginSignUp}
                        </a>
                    </p>
                </div>
                <div className="mt-xl"></div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        account: state.authentication.account,
        user: state.contacts.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserAuthentication: (email) => dispatch(AuthenticationActions.getUserAuthentication(email)),
        getUserEnvironment: (email) => dispatch(AuthenticationActions.getUserEnvironment(email)),
        selectUserEnvironment: (index) => dispatch(AuthenticationActions.selectUserEnvironment(index)),
        selectUserAuthentication: (index) => dispatch(AuthenticationActions.selectUserAuthentication(index)),
        login: (data) => dispatch(AuthenticationActions.login(data)),
        clearEnvironment: () => dispatch(AuthenticationActions.clearEnvironment()),
        clearAuthentication: () => dispatch(AuthenticationActions.clearAuthentication()),
        getSsoLoginUrl: (ssoUrl, challenge, version) => dispatch(AuthenticationActions.getSsoLoginUrl(ssoUrl, challenge, version))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);